import { render, staticRenderFns } from "./AppBarSpace.vue?vue&type=template&id=6ac58879&scoped=true&"
import script from "./AppBarSpace.js?vue&type=script&lang=js&"
export * from "./AppBarSpace.js?vue&type=script&lang=js&"
import style0 from "./AppBarSpace.scss?vue&type=style&index=0&id=6ac58879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac58879",
  null
  
)

export default component.exports